import { Box, Popover } from "@material-ui/core";
import styled from "styled-components";
import { COLORS, FONTS } from "Styles/Constants";

export const MapWrapper = styled.div`
  .pin-icon {
    width: 20px;
    height: 20px;
  }
  .ict-bin {
    width: 20px;
    height: 40px;
  }
  .batt-bin {
    width: 20px;
    height: 40px;
  }
  .bb-bin {
    width: 40px;
    height: 40px;
  }
  .e-drive-bin {
    width: 30px;
    height: 30px;
  }
  .depot-only-bin {
    width: 45px;
    height: 45px;
  }
  .depot-drop-off-bin {
    width: 30px;
    height: 30px;
  }
  .manned-collection-bin {
    width: 35px;
    height: 30px;
  }
`;

export const MapMarkerPopover = styled(Popover)`
  && {
    z-index: 1200;

    .popover-content {
      background-color: white;
      color: ${COLORS.APP_TERTIRY};
      /* height: 105px; */
      width: 320px;
      /* height: 250px; */
      border-radius: 10px;

      .map-detail-header {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 6px 6px 0;

        //background-color: #3de2ea;
      }
      .three-bin {
        background-color: #53c12f;
      }
      .battery-bin {
        background-color: #c4105a;
      }
      .battery-bulb-bin {
        background-color: #3de2ea;
      }
      .e-drive {
        background-color: #7f7f7f;
      }
      .depot-only {
        background-color: #0097a8;
      }
      .depot-drop-off {
        background-color: #f05688;
      }
      .manned-collection {
        background-color: #a57222;
      }
      .map-detail-title {
        font-size: 14px;
        font-weight: 600;
        font-family: ${FONTS.PRIMARY};
        color: #fff;
        margin-left: 20px;
      }
      .map-detail-container {
        color: ${COLORS.APP_PRIMARY};
        padding: 16px;
        justify-content: space- around;

        .map-details-distance-chip {
          width: fit-content;
        }
        .map-detail-sub-text {
          margin-top: 10px;
          margin-left: 5px;
          font-size: 12px;
          font-family: ${FONTS.PRIMARY};
        }

        .map-detail-project-button {
          width: 90px;
          font-size: 10px;
          margin: 0;
        }

        .block-with-text {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .flex {
          display: flex;
          flex-direction: column;
        }

        .description-text {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          line-height: 1.4em;
          max-height: 5.2em;
          flex: 1;
          margin: 5px 0px 0px 5px;
        }
        .bin-images-container {
          display: flex;
          max-width: 500px;
          overflow-y: hidden;
          overflow-x: auto;
          //margin-top: 15px;
        }
        .bin-images-mini-container {
          display: flex;
          max-width: 500px;
          overflow-y: hidden;
          overflow-x: auto;
          padding: 10px;
          ::-webkit-scrollbar {
            width: 100px;
            height: 5px;
            padding: 0rem 1rem;
          }
          ::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          ::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 10px;
          }
          ::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .bin-images {
            width: 200px;
            height: 100px;
            margin-right: 15px;
            cursor: pointer;
          }
        }

        .bin-image {
          width: 80px;
        }
      }
    }

    .marker-container {
      padding-top: 0;

      .marker-item {
        height: calc(100% - 52px);

        .marker-box-container {
          height: 100%;
        }
      }
      .marker-list-item {
        padding-top: 0px;
        padding-bottom: 0px;
      }
      .marker-box-container {
        justify-content: space-between;
        align-items: flex-start;
        color: ${COLORS.APP_SECONCARY};
      }

      .marker-header-container {
        color: ${COLORS.APP_TERTIRY};

        .marker-header-text {
          padding: 16px;
          font-weight: bold;
          font-size: 16px;
          font-family: ${FONTS.PRIMARY};
        }
      }

      .marker-save-button {
        font-size: 16px;
        font-weight: 500;
        padding-bottom: 5px;
        font-family: ${FONTS.PRIMARY};
      }
    }

    .popover-paper {
      overflow-x: unset;
      overflow-y: unset;
      border-radius: 10px;

      &::after {
        content: "";
        position: absolute;
        bottom: -14px;
        left: 96px;
        border-style: solid;
        border-width: 15px 30px 0;
        border-color: white transparent;
        display: block;
        width: 0;
        z-index: 1;
      }
    }

    .popover-right {
      &::after {
        content: "";
        position: absolute;
        left: -134px;
        top: -15%;
        border-style: solid;
        border-width: 15px 30px 0;
        border-color: white transparent;
        display: block;
        width: 0;
        z-index: 1;
        transform: rotate(90deg);
      }
    }

    .popover-bottom {
      &::after {
        content: "";
        position: absolute;
        left: 96px;
        bottom: 97%;
        border-style: solid;
        border-width: 15px 30px 0;
        border-color: white transparent;
        display: block;
        width: 0;
        z-index: 1;
        transform: rotate(180deg);
      }
    }

    .popover-left {
      &::after {
        content: "";
        position: absolute;
        left: 133%;
        top: -15%;
        border-style: solid;
        border-width: 15px 30px 0;
        border-color: white transparent;
        display: block;
        width: 0;
        z-index: 1;
        transform: rotate(270deg);
      }
    }
  }
`;

export const Wrapper = styled(Box)`
  .hide-scrollbar {
    .example::-webkit-scrollbar {
      display: none;
    }
  }
`;
